import React from "react";

const BlogsHero: React.FC = () => {
  return (
    <section className="bp-hero lr-grain">
      <div className="bp-hero__orbs">
        <div className="bp-hero__orb bp-hero__orb--1" />
        <div className="bp-hero__orb bp-hero__orb--2" />
      </div>

      <div className="bp-hero__content">
        <span className="bp-hero__badge">
          <span />
          The eZy Journal
        </span>
        <h1 className="bp-hero__title">
          Latest <span className="lr-text-gradient">Blogs</span>
        </h1>
        <p className="bp-hero__subtitle">
          Guides, stories and product notes on protecting your photos, building a personal
          brand and getting more out of eZy Watermark.
        </p>
      </div>
    </section>
  );
};

export default BlogsHero;
